import React from 'react'
import { Card, Typography, Avatar, IconButton, useTheme } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import CallIcon from '@mui/icons-material/Call'
import EmailIcon from '@mui/icons-material/Email'
import ChatIcon from '@mui/icons-material/Chat'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import Colors from '../../../utils/colors.json'

const styles = (theme: any) => ({
  card: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
    position: 'relative',
    height: '100%',
  },
  avatar: {
    width: 80,
    height: 80,
    marginBottom: 8,
  },
  name: {
    fontWeight: 500,
    fontSize: '20px',
  },
  subtitle: {
    color: Colors.TEXT_COLOR_TERTIARY,
    marginBottom: 16,
    textAlign: 'center',
    fontSize: '13px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%',
    marginTop: 16,
  },
  editButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    color: Colors.TEXT_COLOR_SECONDARY,
    padding: 5,
    backgroundColor: '#D9D9D9',
    borderRadius: '50%',
    fontSize: 35,
  },
  actionIcon: {
    color: Colors.TEXT_COLOR_SECONDARY,
    padding: 5,
    backgroundColor: '#D9D9D9',
    borderRadius: '50%',
    fontSize: 35,
  },
  fieldValue: {
    fontWeight: 400,
    color: Colors.TEXT_COLOR_MAIN,
    fontSize: theme.typography.pxToRem(14),
  },
})

const ProfileCard = ({
  actions,
  isMrnAba,
  section,
}: {
  actions?: boolean
  isMrnAba?: boolean
  section?: React.ReactNode
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <Card className={classes?.card} elevation={0}>
      {actions && (
        <IconButton className={classes?.editButton}>
          <EditIcon />
        </IconButton>
      )}
      <Avatar
        className={classes?.avatar}
        src='https://i.pravatar.cc/150?img=1'
        alt='Profile Picture'
      />
      <Typography variant='h6' className={classes?.name}>
        Joel Mihavel, 49 Years
      </Typography>
      <Typography variant='body2' className={classes?.subtitle}>
        Teacher, Ryan International School
      </Typography>
      {isMrnAba && (
        <Typography variant='body2' className={classes?.subtitle}>
          MRN NO - <span className={classes?.fieldValue}>8989897</span> &nbsp;
          ABA ID -<span className={classes?.fieldValue}>898ABC9897</span>
        </Typography>
      )}
      {actions && (
        <div className={classes?.actions}>
          <IconButton>
            <CallIcon className={classes?.actionIcon} fontSize='small' />
          </IconButton>
          <IconButton>
            <EmailIcon className={classes?.actionIcon} fontSize='small' />
          </IconButton>
          <IconButton>
            <ChatIcon className={classes?.actionIcon} fontSize='small' />
          </IconButton>
        </div>
      )}
      {section}
    </Card>
  )
}

export default ProfileCard
